<template>
  <div class="layout">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 100;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div style="padding: 20px 40px; width: 100%; position: relative; overflow: auto;">
      <div style="text-align: left;">
        <el-radio-group v-model="page" fill="#666">
          <el-radio-button label="1">編輯品項</el-radio-button>
          <el-radio-button label="2">用戶購買紀錄</el-radio-button>
        </el-radio-group>
      </div>
      <div style="text-align: right; min-width: 1000px; margin-bottom: 5px;" v-if="page === '1'">
        <span style="margin-right: 5px" v-if="shop.items.length < maxItem">{{ shop.items.length }}/{{ maxItem }}</span>
        <span style="margin-right: 5px; color: #f24;" v-else>{{ shop.items.length }}/{{ maxItem }}</span>
        <el-tooltip class="item" effect="dark" :content="`品項上限為 ${maxItem} 組，如有需求可額外加購`" placement="top">
          <i class="el-icon-info" style="color: #777; transform: scale(1.1); cursor: pointer;"></i>
        </el-tooltip>
      </div>
      <div style="min-width: 1000px;" v-if="page === '1'">
        <el-row>
          <el-col :span="2">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-left: 1px solid #eee; border-bottom: 1px solid #555;">圖片</div>
          </el-col>
          <el-col :span="3">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-bottom: 1px solid #555;">標題</div>
          </el-col>
          <el-col :span="5">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-bottom: 1px solid #555;">商品內容</div>
          </el-col>
          <el-col :span="5">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-bottom: 1px solid #555;">注意事項</div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-bottom: 1px solid #555;">兌換資訊</div>
          </el-col>
          <el-col :span="5">
            <div style="text-align: left; padding: 5px 15px; font-size: 16px; background-color: #fff; border-bottom: 1px solid #555;">操作</div>
          </el-col>
        </el-row>
      </div>
      <div style="height: calc(100vh - 320px); min-width: 1000px; overflow: auto; position: relative;" v-if="page === '1'">
        <SlickList lockAxis="y" v-model="shop.items" :lockToContainerEdges="true" :distance="10">
          <SlickItem v-for="(element, index) in shop.items" :index="index" :key="index + 's'" style="border: 1px solid #eee; padding: 5px 5px; margin-bottom: -1px; background-color: #fff; cursor: pointer; height: 100px; overflow: hidden;">
            <el-row>
              <!-- 圖片 -->
              <el-col :span="2" style="text-align: left;">
                <img style="padding-left: 5px; width: 95%; max-width: 95px;" :src="element.imageUrl"/>
              </el-col>
              <!-- 標題 -->
              <el-col :span="3">
                <h3 style="text-align: left; padding: 0 10px; margin-top: 0;">{{ element.title }}</h3>
              </el-col>
              <!-- 商品內容 -->
              <el-col :span="5">
                <ol style="text-align: left; padding-left: 30px; margin-top: 0;">
                  <li v-for="(con, index) in element.detail.content"
                    style="font-size: 15px;"
                    :key="index + 'c'">{{ element.detail.content ? con : '無' }}
                  </li>
                </ol>
              </el-col>
              <!-- 注意事項 -->
              <el-col :span="5">
                <ol style="text-align: left; padding-left: 30px; margin-top: 0;">
                  <li v-for="(not, index) in element.detail.notice"
                    style="font-size: 15px;"
                    :key="index + 'n'">{{ element.detail.notice ? not : '無' }}
                  </li>
                </ol>
              </el-col>
              <!-- 點數 -->
              <el-col :span="4">
                <div style="text-align: left; padding-left: 18px;">
                  <!-- 所需點數 -->
                  <div style="margin-bottom: 7px;">
                    所需點數 :<span style="color: #00c300; font-weight: 500;"> {{ element.point }}</span>
                  </div>
                  <!-- 所需等級 -->
                  <div style="margin-bottom: 7px;">
                    所需等級 :<span style="color: #000;"> {{ element.level ? element.level : '無' }}</span>
                  </div>
                  <!-- 可兌換次數 -->
                  <div style="margin-bottom: 7px;">
                    可兌換次數 :<span style="color: #000;"> {{ (element.redeem && element.redeem === '2') ? element.maxRedeem : '無限制' }}</span>
                  </div>
                </div>
              </el-col>
              <!-- 操作 -->
              <el-col :span="5">
                <div style="margin-top: 10px; text-align: left; padding-left: 18px;">
                  <el-button style="margin-right: 10px;" type="primary" @click="openDia(index)" size="small" plain>編輯</el-button>
                  <el-button style="margin-left: 0px;" type="danger" size="small" @click="deleteShopItem(index)" plain>刪除</el-button>
                  <el-button type="info" icon="el-icon-copy-document" @click="copyItem(index)" size="small" plain></el-button>
                </div>
              </el-col>
            </el-row>
          </SlickItem>
        </SlickList>
      </div>
      <!-- 確認刪除 -->
      <mu-dialog :open="deleteDia" title="確認訊息" width="550" style="text-align: center; min-width: 650px;" scrollable>
        <div style="text-align: left">確定要刪除這個商品嗎? 刪除後將無法復原</div>
        <mu-button slot="actions" flat color="primary" @click="deleteDia = false">返 回</mu-button>
        <mu-button slot="actions" color="primary" @click="checkDelete">確 定</mu-button>
      </mu-dialog>
      <!-- 編輯 -->
      <el-dialog :visible.sync="openEdit" fullscreen :show-close="false">
        <mu-appbar color="primary" title="商品內容" style="position: fixed; width: calc(100vw - 40px); top: 0;">
          <mu-button style="margin-right: 10px;" slot="right" @click="cancelAdd" v-if="editType === 'add'">取消</mu-button>
          <mu-button style="margin-right: 10px;" slot="right" @click="completeEdit">完成</mu-button>
        </mu-appbar>
        <div style="margin-top: 0px;">
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row style="border: 1px solid #eee; padding: 15px; height: 210px;" v-if="shop.items[itemIdx]">
                <el-col :span="10" style="position: relative;">
                  <div style="width: 180px; height: 180px; border: 1px solid #eee; overflow: hidden; position: relative;">
                    <img style="position: absolute; top: 50%; transform: translateY(-50%); width: 100%;" :src="shop.items[itemIdx].imageUrl"/>
                  </div>
                </el-col>
                <el-col :span="14" style="padding: 15px;">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">標題:</div>
                    <el-input placeholder="請輸入標題"
                      :disabled="editType === 'edit'"
                      style="width: 100%;"
                      v-model="shop.items[itemIdx].title">
                    </el-input>
                    <div style="color: #f24">{{ noTitle }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                    <label style="height: 40px; line-height: 40px; padding: 8px 14px; border-radius: 4px; cursor: pointer; background-color: #888; color: #fff; font-weight: 500;">
                      <input style="display:none;" type="file" @change="onFileSelected">上傳圖片<i class="el-icon-upload2"></i>
                    </label>
                  </div>
                  <div style="margin-top: 5px;" v-if="loading">
                    <el-progress :percentage="percentage" :color="color" :show-text="false"></el-progress>
                  </div>
                </el-col>
              </el-row>
              <!-- 內容 -->
              <el-row style="border: 1px solid #eee; padding: 15px;" v-if="shop.items[itemIdx] && shop.items[itemIdx].detail">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">內容: <span style="color: #f24;">{{alertMsg}}</span></div>
                    <div v-for="(con, index) in shop.items[itemIdx].detail.content" :key="index + 'co'">
                      <el-row :gutter="10">
                        <el-col :span="20">
                          <el-input placeholder="請輸入商品內容"
                            v-model="shop.items[itemIdx].detail.content[index]" style="margin-bottom: 10px; width: 100%;">
                          </el-input>
                        </el-col>
                        <el-col :span="4">
                          <el-button type="danger" style="width: 100%;" @click="deleteItem('content', index)">刪除</el-button>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="text-align: center;">
                      <i class="el-icon-circle-plus-outline plus" @click="addItem('content')"></i>
                    </div>
                  </div>
                </el-col> 
              </el-row>
              <!-- 注意事項 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx] && shop.items[itemIdx].detail">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">注意事項: <span style="color: #f24;">{{alertMsg2}}</span></div>
                    <div v-for="(con, index) in shop.items[itemIdx].detail.notice" :key="index + 'co'">
                      <el-row :gutter="10">
                        <el-col :span="20">
                          <el-input placeholder="請輸入注意事項"
                            v-model="shop.items[itemIdx].detail.notice[index]" style="margin-bottom: 10px; width: 100%;">
                          </el-input>
                        </el-col>
                        <el-col :span="4">
                          <el-button type="danger" style="width: 100%;" @click="deleteItem('notice', index)">刪除</el-button>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="text-align: center;">
                      <i class="el-icon-circle-plus-outline plus" @click="addItem('notice')"></i>
                    </div>
                  </div>
                </el-col> 
              </el-row>
              <!-- 所需點數 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx]">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">所需點數: <span style="color: #f24;">{{alertMsg3}}</span></div>
                    <el-input placeholder="請輸入所需點數"
                      v-model.number="shop.items[itemIdx].point" style="margin-bottom: 3px; width: 80%;">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <!-- 所需等級 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx]">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">所需等級:</div>
                    <el-radio-group v-model="shop.items[itemIdx].level">
                      <el-radio v-for="item in levelList" :key="item.title" :label="item.title" style="margin-bottom: 5px;"></el-radio>
                    </el-radio-group>
                  </div>
                </el-col>
              </el-row>
              <!-- 可兌換次數 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx]">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">可兌換次數: <span style="color: #f24;">{{alertMsg4}}</span></div>
                    <el-radio-group v-model="shop.items[itemIdx].redeem">
                      <el-radio label="1">無限制</el-radio>
                      <el-radio label="2">限制</el-radio>
                    </el-radio-group>
                    <span v-if="shop.items[itemIdx].redeem === '2'" style="font-size: 15px;">，最多
                      <el-input size="small" v-model.number="shop.items[itemIdx].maxRedeem" style="margin-bottom: 3px; width: 15%"></el-input> 次
                    </span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <!-- 第二列 -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <!-- 可兌換門市 -->
              <el-row style="border: 1px solid #eee; padding: 15px;" v-if="shop.items[itemIdx]">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">可兌換門市:</div>
                    <mu-select label="可多選" multiple v-model="shop.items[itemIdx].openStore" full-width style="margin-bottom: 5px;" @change="getSelectedStore(itemIdx)">
                      <mu-option v-for="(store, index) in storeList" :key="index + 's'" :label="store" :value="store"></mu-option>
                    </mu-select>
                    <mu-checkbox @change="getVal(itemIdx)" value="all" v-model="shop.items[itemIdx].selectAll" label="全選"></mu-checkbox>
                  </div>
                </el-col>
              </el-row>
              <!-- 可兌換TAG -->
              <el-row style="border: 1px solid #eee; padding: 15px;" v-if="shop.items[itemIdx] && tagList.length > 0">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 10px;">
                      <el-radio-group v-model="shop.items[itemIdx].tagType">
                        <el-radio label="特定標籤"></el-radio>
                        <el-radio label="生日標籤"></el-radio>
                      </el-radio-group>
                    </div>
                    <!-- 特定標籤 -->
                    <div v-if="shop.items[itemIdx].tagType === '特定標籤'">
                      <mu-select label="可多選" multiple v-model="shop.items[itemIdx].specificTag" full-width style="margin-bottom: 5px;" :disabled="shop.items[itemIdx].specificTag.indexOf('無限制') !== -1">
                        <mu-option v-for="(tag, index) in filterTag(tagList, '1')" :key="index + 't'" :label="tag" :value="tag"></mu-option>
                      </mu-select>
                    </div>
                    <!-- 生日標籤 -->
                    <div v-if="shop.items[itemIdx].tagType === '生日標籤'">
                      <mu-select label="可多選" multiple v-model="shop.items[itemIdx].specificTag" full-width style="margin-bottom: 5px;" :disabled="shop.items[itemIdx].specificTag.indexOf('無限制') !== -1">
                        <mu-option v-for="(tag, index) in filterTag(tagList, '2')" :key="index + 't'" :label="tag" :value="tag"></mu-option>
                      </mu-select>
                    </div>
                    <div>
                      <mu-checkbox @change="setEmpty(itemIdx)" value="無限制" v-model="shop.items[itemIdx].specificTag" label="無限制"></mu-checkbox>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <!-- 兌換碼 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx] && openRedeem">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">兌換碼:</div>
                    <el-radio-group v-model="shop.items[itemIdx].isCode">
                      <el-radio label="1">無</el-radio>
                      <el-radio label="2">有</el-radio>
                    </el-radio-group>
                    <el-button style="margin-left: 30px;" type="info" size="small" @click="getRandomCode(itemIdx)">產生隨機碼</el-button>
                    <span v-if="shop.items[itemIdx].isCode === '2'" style="font-size: 15px;">
                      <div v-for="(pass, index) in shop.items[itemIdx].verCode" :key="index + 'p'" style="margin: 10px 0;">
                        <span style="font-weight: 500">{{ pass.store }}: </span>
                        <el-input size="small" v-model="pass.code" style="width: 35%"></el-input>
                      </div>
                    </span>
                  </div>
                </el-col>
              </el-row>
              <!-- 兌換編碼 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx] && redeemItemAuth">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">是否開啟兌換編號欄位:</div>
                    <el-switch v-model="shop.items[itemIdx].redeemCode"
                      active-text="開"
                      inactive-text="關">
                    </el-switch>
                  </div>
                </el-col>
              </el-row>
              <!-- 推播訊息 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx] && shop.items[itemIdx].detail">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">完成推播訊息:</div>
                    <el-input placeholder="請輸入內容"
                      :rows="3"
                      type="textarea"
                      v-model="shop.items[itemIdx].detail.reply"
                      style="margin-bottom: 3px; width: 80%;">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <!-- 推播訊息 -->
              <el-row style="border: 1px solid #eee; padding: 15px; border-top: none;" v-if="shop.items[itemIdx]">
                <el-col :span="24">
                  <div style="text-align: left;">
                    <div style="margin-bottom: 8px; font-weight: 500;">是否顯示給非條件會員:</div>
                    <el-radio v-model="shop.items[itemIdx].noShow" label="false">顯示但反灰</el-radio>
                    <el-radio v-model="shop.items[itemIdx].noShow" label="true">不顯示</el-radio>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <!-- 結束按鈕 -->
        <mu-button slot="actions" flat color="primary" @click="checkUpdate">確 定</mu-button>
      </el-dialog>
      <mu-dialog :open="shopFirst" title="系統通知" width="450">
        設定商城前請先設定門市資訊哦～
        <mu-button slot="actions" color="primary" @click="gotoStore">前 往</mu-button>
      </mu-dialog>
      <div style="text-align: right; margin-top: 20px; min-width: 1000px; overflow: auto;" v-if="page === '1'">
        <el-button type="info" @click="addShopItem" :disabled="shop.items.length >= maxItem">新增品項</el-button>
        <el-button type="primary" @click="sendPush">儲存變更</el-button>
      </div>
      <div v-if="page === '2'" style="text-align: left; position: relative; margin-top: 20px;">
        <iframe :src="sheetUrl" frameborder="0" width="1100px" style="border: 1px solid #eee; height: calc(100vh - 250px)"></iframe>
        <!-- <div style="position: absolute; bottom: 0px; height: 45px; background-color: rgb(238, 238, 238); width: 660px;"></div> -->
      </div>
    </div>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
import { SlickList, SlickItem } from 'vue-slicksort';
import { mapActions } from 'vuex';
// import { get } from '../../firebase';
/* eslint-disable */
const defaultContent = {
  detail: {
    content: ['這裡是商品內容的文字'],
    notice: ['這裡是注意事項的文字'],
    reply: null
  },
  imageUrl: 'https://screenshotlayer.com/images/assets/placeholder.png',
  point: 0,
  title: '標題範例文字'
};

export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      openRedeem: false,
      openEdit: false,
      linkText: false,
      loading: false,
      deleteDia: false,
      shopFirst: false,
      redeemItemAuth: false,
      deleteIdx: 0,
      itemIdx: 0,
      selectAll: [],
      storeList: [],
      tagList: [],
      multipleSelection: [],
      isSheet: false,
      sheetUrl: '',
      alertMsg: '',
      alertMsg2: '',
      alertMsg3: '',
      alertMsg4: '',
      noTitle: '',
      levelList: ['無'],
      page: '1',
      editType: 'add',
      percentage: 0,
      color: '#409eff',
      maxItem: 10,
      shop: {
        items: []
      }
    };
  },
  mounted() {
    this.checkWhiteList({ auth: this.auth, type: 'shopItem' })
      .then((res) => {
        if (res.Detail) {
          this.maxItem = res.Detail.num ? res.Detail.num : 50;
        }
      })
    this.checkWhiteList({ auth: this.auth, type: 'redeemCode' })
      .then((res) => {
        if (res.Detail) {
          this.openRedeem = true;
        }
      })
    this.getShopDetail();
    this.getAllTags({ service: this.service, auth: this.auth })
      .then((res) => {
        if (res && res.Tags.length > 0) {
          this.tagList = res.Tags.map(el => el[0]);
        }
        else {
          this.tagList = [];
        }
      })
    this.getRedeemItem({ clientId: this.auth }).then((_msg) => {
      if (_msg.data.Message === '可使用兌換碼') {
        this.redeemItemAuth = true;
      }
      else {
        this.redeemItemAuth = false;
      }
    })
  },
  components: {
    SlickItem,
    SlickList,
  },
  computed: {
    itemNameArr() {
      return this.shop.items.map(el => el.title);
    }
  },
  methods: {
    ...mapActions({
      checkWhiteList: 'checkWhiteList',
      checkAccount: 'checkAccount',
      getRedeemItem: 'getRedeemItem',
      updateAccount: 'updateAccount',
      getAllTags: 'getAllTags'
    }),
    filterTag(list, type) {
      if (type === '1') {
        return list.filter(el => el.indexOf('ELS_BIRTH') === -1)
      }
      return list.filter(el => el.indexOf('ELS_BIRTH') !== -1);
    },
    getSheet(url) {
      this.sheetUrl = `https://docs.google.com/spreadsheets/d/e/${url}/pubhtml?gid=0&single=false&widget=true&headers=false&chrome=true`;
    },
    gotoStore() {
      this.$router.push(`/store/${this.service}/${this.auth}`);
    },
    setEmpty(index) {
      if (this.shop.items[index].specificTag.indexOf('無限制') !== -1) {
        this.shop.items[index].specificTag = ['無限制'];
      }
    },
    cancelAdd() {
      this.shop.items.splice(this.itemIdx, 1);
      this.openEdit = false;
    },
    completeEdit() {
      const itemDetail = this.shop.items[this.itemIdx];
      if (!itemDetail.title) {
        this.noTitle = '請輸入商品標題';
      }
      else if (this.itemNameArr.filter(el => el === itemDetail.title).length > 1) {
        this.noTitle = '已經有重複的商品名稱';
      }
      else {
        this.noTitle  = '';
        this.openEdit = false;
      }
    },
    getVal(index) {
      if (this.shop.items[index].selectAll && this.shop.items[index].selectAll.indexOf('all') !== -1) {
        let defaultVer = [];
        for (var e = 0; e < this.storeList.length; e += 1) {
          defaultVer[e] = {
            store: this.storeList[e],
            code: ''
          };
        }
        this.shop.items[index].openStore = this.storeList;
        this.shop.items[index].verCode = defaultVer;
      }
      else {
        this.shop.items[index].openStore = [];
        this.shop.items[index].verCode = [];
      }
    },
    getSelectedStore(index) {
      const openStore = this.shop.items[index].openStore;
      let defaultVer = [];
      for (var e = 0; e < openStore.length; e += 1) {
        defaultVer[e] = {
          store: openStore[e],
          code: ''
        };
      }
      this.shop.items[index].verCode = defaultVer;
    },
    getShopDetail() {
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      this.checkAccount({ Service: this.service, Auth: this.auth })
        .then((res) => {
          loading.close();
          if (res.store) {
            this.storeList = res.store ? Object.keys(res.store) : [];
            if (res.itemList) {
              this.isSheet = true;
              this.getSheet(res.itemList);
            }
            if (res && res.level && res.level.list) {
              this.levelList = res.level.list.concat([{ title: '無' }]);
            }
            if (res && res.shop) {
              const shopItemArr = [];
              for (let i = 0; i < res.shop.items.length; i += 1) {
                let defaultVer = [];
                const stores = Object.keys(res.store);
                for (var e = 0; e < stores.length; e += 1) {
                  defaultVer[e] = {
                    store: stores[e],
                    code: ''
                  };
                }
                shopItemArr[i] = {
                  imageUrl: res.shop.items[i].imageUrl,
                  point: res.shop.items[i].point,
                  title: res.shop.items[i].title,
                  level: res.shop.items[i].level,
                  redeem: res.shop.items[i].redeem ? res.shop.items[i].redeem : '1',
                  isCode: res.shop.items[i].isCode ? res.shop.items[i].isCode : '1',
                  selectAll: res.shop.items[i].selectAll ? res.shop.items[i].selectAll : [],
                  openStore: res.shop.items[i].openStore ? res.shop.items[i].openStore : [],
                  tagType: res.shop.items[i].tagType ? res.shop.items[i].tagType : '特定標籤',
                  specificTag: res.shop.items[i].specificTag ? res.shop.items[i].specificTag : [],
                  verCode: res.shop.items[i].verCode ? res.shop.items[i].verCode : defaultVer,
                  noShow: res.shop.items[i].noShow ? res.shop.items[i].noShow : 'false',
                  redeemCode: res.shop.items[i].redeemCode ? res.shop.items[i].redeemCode : false,
                  maxRedeem: res.shop.items[i].maxRedeem ? res.shop.items[i].maxRedeem : null,
                  detail: {
                    content: res.shop.items[i].detail.content ? res.shop.items[i].detail.content : [],
                    notice: res.shop.items[i].detail.notice ? res.shop.items[i].detail.notice : [],
                    reply: res.shop.items[i].detail.reply ? res.shop.items[i].detail.reply : null
                  }
                }
              }
              this.shop.items = shopItemArr;
            }
          }
          else {
            this.shopFirst = true;
          }
        });
    },
    openLink() {
      this.linkText = true;
    },
    upload() {
      this.linkText = false;
    },
    openDia(row) {
      this.editType = 'edit';
      this.openEdit = true;
      this.itemIdx = row;
      this.linkText = false;
    },
    getRandomCode(idx) {
      for (let i = 0; i < this.shop.items[idx].verCode.length; i += 1) {
        let code = '';
        const random = new Array('0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R', 
'S','T','U','V','W','X','Y','Z');
        for (let e = 0; e < 6; e += 1) {
          const index = Math.floor(Math.random() * 36);
          code += random[index];
        }
        this.shop.items[idx].verCode[i].code = code;
      }
    },
    copyItem(index) {
      let nowItem = JSON.parse(JSON.stringify(this.shop.items[index]));
      nowItem.title = '';
      this.shop.items.push(nowItem);
      this.itemIdx = this.shop.items.length - 1;
      this.editType = 'add';
      this.openEdit = true;
    },
    addShopItem() {
      this.editType = 'add';
      let defaultVer = [];
      for (var e = 0; e < this.storeList.length; e += 1) {
        defaultVer[e] = {
          store: this.storeList[e],
          code: ''
        };
      }
      this.shop.items.push({
        detail: {
          content: ['這裡是商品內容的文字'],
          notice: ['這裡是注意事項的文字'],
          reply: null
        },
        imageUrl: 'https://screenshotlayer.com/images/assets/placeholder.png',
        point: 0,
        noShow: 'false',
        openStore: [],
        selectAll: [],
        specificTag: [],
        tagType: '特定標籤',
        verCode: defaultVer,
        title: '標題範例文字'
      });
      this.itemIdx = this.shop.items.length - 1;
      this.openEdit = true;
    },
    addItem(type) {
      this.shop.items[this.itemIdx].detail[type].push('');
    },
    deleteShopItem(row) {
      this.deleteDia = true;
      this.deleteIdx = row;
    },
    deleteItem(type, idx) {
      this.shop.items[this.itemIdx].detail[type].splice(idx, 1);
    },
    checkUpdate() {
      const validNumber = parseInt(this.shop.items[this.itemIdx].point);
      if (this.shop.items[this.itemIdx].detail.content && this.shop.items[this.itemIdx].detail.content.indexOf('') !== -1) {
        this.alertMsg = '(如有不必要的項目請刪除)';
        return;
      }
      if (this.shop.items[this.itemIdx].detail.notice && this.shop.items[this.itemIdx].detail.notice.indexOf('') !== -1) {
        this.alertMsg2 = '(如有不必要的項目請刪除)';
        return;
      }
      if (typeof validNumber !== 'number' || isNaN(validNumber)) {
        this.alertMsg3 = '(請輸入有效數字哦)';
        return;
      }
      if (this.shop.items[this.itemIdx].redeem === '2' && (!this.shop.items[this.itemIdx].maxRedeem || this.shop.items[this.itemIdx].maxRedeem === '')) {
        this.alertMsg4 = '(請輸入有效數字哦)';
        return;
      }
      this.shop.items[this.itemIdx].point = validNumber;
      this.alertMsg = '';
      this.alertMsg2 = '';
      this.alertMsg3 = '';
      this.alertMsg4 = '';
      this.openEdit = false;
    },
    checkDelete() {
      this.deleteDia = false;
      this.shop.items.splice(this.deleteIdx, 1);
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    sendPush() {
      // const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      const content = {
        shop: this.shop
      };
      this.updateAccount({ service: this.service, auth: this.auth, content: content });
      this.$notify({
        title: '已更新商城內容',
        type: 'success'
      });
    },
    // 上傳圖片到 DB
    onFileSelected(event) {
      this.loading = true;
      var vi = setInterval(() => {
        this.percentage += 4;
      }, 100);
      // 使用者 uid
      const uid = localStorage.getItem('UserID');
      // 檔案
      const file = event.target.files[0];

      const formData = new FormData();
      formData.append('uid', uid);
      formData.append('myfile', file);

      const config = {
        header: {
          "content-type": "multipart/form-data"
        }
      };
      // 上傳表單資料
      this.axios.post('https://firebase-member-node.herokuapp.com/upload', formData, config)
        .then((res) => {
          this.shop.items[this.itemIdx].imageUrl = res.data.url;
          setTimeout(() => {
            this.loading = false;
            clearInterval(vi);
          }, 1000)
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading = false;
            clearInterval(vi);
          }, 1000)
          this.$notify({
            title: '上傳失敗',
            message: err,
            type: 'error'
          });
        });
    },
  }
}
</script>

<style scoped>
.titleBlock {
  background-color: #555;
  text-align: center;
  color: #fff;
  display: inline-block;
  font-size: 25px;
  font-weight: 500;
  padding: 4px 30px;
  border-radius: 5px;
}
.plus:hover {
  color: rgb(64, 158, 255);
}
.plus {
  transition: 0.2s;
  cursor: pointer;
  font-size: 25px;
  margin-top: 10px;
  font-weight: 500;
  color: #777;
}
.uploadImg:hover {
  opacity: 0.8;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading {
  margin-top: 10px;
  border: 3px solid #bdbbbb;
  border-radius: 50%;
  border-top: 3px solid #7c0c0c;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 0.5s linear infinite; /* Safari */
  animation: spin 0.5s linear infinite;
}
.uploadImg {
  display: inline-block;
  font-size: 12px;
  padding: 7.5px 15px;
  background-color: #409eff;
  color: #fff;
  margin-right: 10px;
  border-radius: 3px;
  cursor: pointer;
}
.itembox {
  padding: 20px 20px 14px 20px;
  margin-bottom: 10px;
}
#content {
  margin-top: 20px;
  padding: 0 30px;
}
.layout {
  min-width: 100%;
  max-width: 100%;
  padding-top: 80px;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.settingbox {
  border: 1px solid #999;
}
.displaybox {
  border: 1px solid #999;
  padding: 20px;
}
.contain {
  padding: 40px 65px;
}
.contain2 {
  padding: 20px;
  margin-bottom: 20px;
}
</style>